import React, { cloneElement } from 'react';
import { Image } from 'components/image/Image';
import { Link } from 'components/link/Link';

import Logo from 'assets/svg/instagram.svg';

import s from './Instagram.scss';

interface IProps {
  offset?: boolean;
  link: string;
  text: string;
  image: string;
  width: number;
  height: number;
  profile: string;
}

export const Instagram = ({ offset, link, text, image, width, height, profile }: IProps) => {
  if (!image) {
    return null;
  }

  const profileEl = (
    <span className={s.instagram__profile}>
      <Logo className={s.instagram__logo} /> {profile}
    </span>
  );

  return (
    <div className={s('instagram', { offset })}>
      <div className={s.instagram__inner}>
        <Image className={s.instagram__image} url={image} width={width} height={height} />
        <Link className={s.instagram__link} to={link}>
          {profileEl}
        </Link>
        <div className={s.instagram__text}>
          {cloneElement(profileEl, {
            'aria-hidden': true,
          })}
          {text}
        </div>
      </div>
    </div>
  );
};
